export const login = {
  'login.title': 'Log in to your account',
  'login.description': 'Don’t have an account?',
  'login.createAccount': 'Create an account',
  'login.login': 'Log in',
}
